import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogContent } from '@mui/material'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import i18n from 'simple-react-i18n'
import { DefaultDialogTitle } from '../styled/Dialog'
import { getGeneralLevelling } from '../../utils/SettingUtils'
import { STATION_TYPE_NAME } from '../../station/constants/StationConstants'
import PiezometryReferenceLevelSchema from '../svg/PiezometryReferenceLevelSchema'
import HydrometryReferenceLevelSchema from '../svg/HydrometryReferenceLevelSchema'

const DEFAULT_NG = 'NGF'

const ReferenceLevelHelp = ({ stationType }) => {
    const [open, setOpen] = useState(false)
    const ng = getGeneralLevelling() || DEFAULT_NG
    const isHydro = stationType === STATION_TYPE_NAME.hydrometry

    return (
        // le bouton est posé dans l'en-tête repliable du popover : sans ça, les clics (y compris dans la popin, via le portail React) replient la section
        <span onClick={e => e.stopPropagation()}>
            <Button
                variant='contained'
                size='small'
                color='warning'
                startIcon={<HelpOutlineIcon />}
                onClick={() => setOpen(true)}
                sx={{ padding: '0 8px', minWidth: 0, lineHeight: 1.6, textTransform: 'none' }}
            >
                {i18n.help}
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)} maxWidth='md' fullWidth>
                <DefaultDialogTitle
                    title={isHydro ? i18n.referenceLevelHelpHydrometry : i18n.referenceLevelHelpPiezometry}
                    onClose={() => setOpen(false)}
                />
                <DialogContent>
                    {isHydro ? <HydrometryReferenceLevelSchema ng={ng} /> : <PiezometryReferenceLevelSchema ng={ng} />}
                </DialogContent>
            </Dialog>
        </span>
    )
}

ReferenceLevelHelp.propTypes = {
    stationType: PropTypes.oneOf([STATION_TYPE_NAME.piezometry, STATION_TYPE_NAME.hydrometry]),
}

export default ReferenceLevelHelp
